// NewHome.jsx
// React Functional Component using pure Tailwind (no external styles.css)

import React, {
  useEffect,
  useRef,
  useState,
  useLayoutEffect,
} from "react";
import {
  motion,
  useMotionValue,
  useScroll,
  useMotionValueEvent,
  useTransform,
} from "framer-motion";

import Logo from "../video/Mariniz Logo Gold.png";
import website_logo from "../../images/website_Logo.png";


import Newbg from "../../images/Newbg.png";
import axios from "axios";
import { toast } from "react-toastify";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import opencargoimage from "../../images/open cargo.png";
import openshipimage from "../../images/open Ship.png";
import browseship from "../../images/Browse ship.png";
import structureBg from "../../images/StructureBg.png";
import Slider from "react-slick";
import config from "../../function/config";
import NewFooter from "../NewFooter";


const navLinks = [
  { label: "Home", path: "/" },
  { label: "Ship Sale/Purchase", path: "/ship-for-sale" },
  { label: "Open Ships", path: "/map/ship-chartering" },
  { label: "Open Cargo", path: "/map/open-cargo" },
  { label: "Contact Us", path: "/contact" },
];




const NewHome = () => {
  const [typing, setTyping] = useState(false);
  const navigate = useNavigate();
  const [inputText, setInputText] = useState("");

  const sellBoatRef = useRef(null);
  const section4Ref = useRef(null);
  const textRef = useRef(null);

  const { id } = useParams();

  const [allShips, setallShips] = useState([]);
  const [allShipsReg, setallShipsReg] = useState([]);

  const [count, setCount] = useState(0);

  // Fetch Admin Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShip`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          const sortedData = res1.data.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setallShips(sortedData);
          setCount(id);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, id]);

  // Fetch Customer Registered Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          const sortedData = res1.data.data.sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          );
          setallShipsReg(sortedData);
          setCount(id);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, id]);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const [allImages, setallImages] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :", res3);
          setallImages(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  // Add an identifier to distinguish Admin Ships and Customer Ships
  const filteredAllShipsReg = allShipsReg
    .filter((ship) => ship.is_allow)
    .map((ship) => ({ ...ship, isFromReg: true }));

  const allShipsWithFlag = allShips.map((ship) => ({
    ...ship,
    isFromReg: false,
  }));

  // Merge and sort ships by created_at (latest first)
  const sortedData = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  const [allImagesReg, setAllImagesReg] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :", res3);
          setAllImagesReg(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  const [shipForSale, setShipForSale] = useState(false);
  const [shipForCharter, setShipForCharter] = useState(false);

 

  /* ---------------- PARALLAX SHIP: HERO → 4th CARD ---------------- */

 
  /* ------------ MARKETPLACE SECTION PARALLAX / ZOOM ------------- */

  
   const ShipsliderRef = useRef(null);

   const NextArrowShip = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute right-3 z-20 top-1/2 transform -translate-y-1/2 bg-blue-500 text-white p-2 w-[50px] h-[50px] rounded-full shadow-lg"
    >
      <i class="fa-solid fa-chevron-right"></i>
    </button>
  );

  const PrevArrowShip = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute z-30 -left-4 top-1/2 transform -translate-y-1/2 bg-blue-500 text-white p-2 w-[50px] h-[50px] rounded-full shadow-lg"
    >
      <i className="fa-solid fa-chevron-left"></i>
    </button>
  );

  
 const ship = {
    infinite: sortedData.length > 1, // Enable infinite scroll only if there are more than 1 cards
    speed: 800,
    slidesToShow: Math.min(4, sortedData.length), // Show fewer slides if there are not enough cards
    slidesToScroll: 1,
    spaceBetween: 5,
    autoplay: true,
    arrows: true,
    dots: false, // Show dots only if there is more than 1 card
    focusOnSelect: true,
    nextArrow: <NextArrowShip />,
    prevArrow: <PrevArrowShip />,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: Math.min(3, sortedData.length),
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(3, sortedData.length),
        },
      },
      {
        breakpoint: 1143,
        settings: {
          slidesToShow: Math.min(3, sortedData.length),
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: Math.min(2, sortedData.length),
        },
      },
      {
        breakpoint: 654,
        settings: {
          slidesToShow: Math.min(1, sortedData.length),
        },
      },
    ],
    
  };

  const [cargos, setAllcargos] = useState([]);

  const [openShip,setOpenShip] = useState([]);


  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewLogistics`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setAllcargos(res1.data.data.reverse());
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);
  /* ---------------------------------------------------------------- */


   useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForCharter`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setOpenShip(res1.data.data.reverse());
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);
   // signin
  const [username, setusername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [Signin, setSignin] = useState("Signin");
    // Validate username
    const validateUsername = (value) => {
      if (!value) {
        setUsernameError("Username is required");
      } else {
        setUsernameError("");
      }
    };
  
    // Validate password
    const validatePassword = (value) => {
      if (!value) {
        setPasswordError("Password is required");
      } else if (value.length < 4) {
        setPasswordError("Password must be at least 4 characters");
      } else {
        setPasswordError("");
      }
    };
  
    const handleSubmit = async () => {
      setLoading(true);
      const data = {
        email: username,
        password: password,
      };
      try {
        const response = await axios.post(
          `${config.base_url}/api/HappyMarineShipping/login`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.status === 200) {
          setLoading(false);
          console.log(response);
          localStorage.setItem("token", response.data.token);
          if (response.data.is_admin === true) {
            localStorage.setItem("admin", "t");
            console.log("Admin token:", response.data.token); // ✅ log admin token
            window.location.href = "/adminHome";
          } else {
            window.location.href = '/userHome'
          }
        } else {
          console.log(response);
          toast.error(response.data.message, {
            autoClose: 3000,
            position: "top-right",
          });
          setLoading(false);
        }
      } catch (err) {
        console.log("error2", err);
        toast.error("Error", {
          autoClose: 3000,
          position: "top-right",
        });
        setLoading(false);
      }
    };
  
    const [showPassword, setShowPassword] = useState(false);
     const [isLoginOpen, setIsLoginOpen] = useState(true);

   const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [image,setImage] = useState('')


  // Error states
  const [emailError, setEmailError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);


    
  
  // Email validation (simple regex)
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!emailRegex.test(value));
  };
  
  const validateMobile = (value) => {
    const mobileRegex = /^\+\d{7,15}$/;
    setMobileError(!mobileRegex.test(value));
  };
  
  
  // Confirm Password validation (must match Password)
  const validateConfirmPassword = (value) => {
    setConfirmPasswordError(value !== password);
  };
  
  
    const handleSubmitSignup = async () => {
    // Run all validations first
    validateUsername(username);
    validateEmail(email);
    validateMobile(mobile);
    validatePassword(password);
    validateConfirmPassword(confirmPassword);
  
    // Check for any errors or empty required fields
    if (
      usernameError ||
      emailError ||
      mobileError ||
      passwordError ||
      confirmPasswordError ||
      !firstName ||
      !lastName ||
      !username ||
      !email ||
      !mobile ||
      !password ||
      !confirmPassword
    ) {
      toast.error("Please fix form validation errors before submitting.", {
        autoClose: 1500,
        position: "top-right",
      });
      return;
    }
  
    setLoading(true);
  
    const formData = new FormData();
    formData.append("email", email);
    formData.append("username", username);
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("phone", mobile);
    formData.append("address", address);
    formData.append("password", password);
    if (image) {
      formData.append("image", image);
    }
  
    try {
      const response = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/signup`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data.status === 200) {
    toast.success("Registered Successfully", {
      autoClose: 1500,
      position: "top-right",
      onClose: () => navigate("/login"),
    });
  } else if (
    response.data.status === 400 &&
    response.data.message === "Email already exists"
  ) {
    toast.error("Email already exists", {
      autoClose: 1500,
      position: "top-right",
    });
  } else if (
    response.data.status === 400 &&
    response.data.message === "Username already exists"
  ) {
    toast.error("Username already exists", {
      autoClose: 1500,
      position: "top-right",
    });
  } else {
    toast.error("Something went wrong. Try again.", {
      autoClose: 1500,
      position: "top-right",
    });
  }
  
    } catch (err) {
      console.error(err);
      toast.error("Network error. Please try again.", {
        autoClose: 1500,
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    

    const [resetEmail, setResetEmail] = useState("");
const [resetLoading, setResetLoading] = useState(false);

const handleForgotPassword = async () => {
  if (!resetEmail) {
    toast.error("Please enter your email");
    return;
  }
  setResetLoading(true);
  try {
    const res = await axios.post(`${config.base_url}/api/HappyMarineShipping/forgot-password/`, {
      email: resetEmail,
    });
    if (res.data.status === 200) {
      toast.success("Reset link sent to your email");
      setSignin("Signin");
    } else {
      toast.error(res.data.message);
    }
  } catch (err) {
    toast.error("Something went wrong");
  } finally {
    setResetLoading(false);
  }
};

const location = useLocation();
  return (
    <div className="min-h-screen   overflow-hidden bg-[#9ccee2] text-slate-900">
  <motion.section
  className="relative mb-16 z-10 px-[110px] 3xl:px-5 w-full min-h-screen bg-cover bg-center bg-no-repeat"
  style={{
    backgroundImage: `url(${structureBg})`,
  }}
>
  {/* Optional soft overlay so text stays readable */}
  <div className="absolute inset-0 bg-gradient-to-b from-white/40 via-white/10 to-transparent" />

  {/* Content layer */}
  <div className="relative   h-full">
    {/* NAVBAR inside hero background */}
    <header className="m-auto xm:flex-col flex items-center justify-between">
      <div className="items-center gap-2">
        <div className="m-auto h-28 w-[250px] items-center justify-center rounded-full text-sm font-extrabold text-white ">
          <img src={Logo} className="m-auto" alt="" />
        </div>
        {/* <span className="text-lg font-semibold tracking-tight text-slate-900">
          Mariniz
        </span> */}
      </div>

      {/* <div className="">
        <i
          onClick={toggleSidebar}
          className={`bx ${isSidebarOpen ? "bx-x" : "bx-menu"} hidden L:block  mt-5 text-white text-[40px] cursor-pointer`}
        ></i>
      </div> */}

      <nav className="flex items-center xl:hidden gap-8 text-[15px] text-slate-600">
  {navLinks.map((item) => {
    const isActive = location.pathname === item.path;
    return (
      <Link
        key={item.label}
        to={item.path}
        className={`transition-colors hover:text-slate-900 ${
          isActive ? "font-semibold text-slate-900" : ""
        }`}
      >
        {item.label}
      </Link>
    );
  })}

  <button
    onClick={() => setIsLoginOpen(true)}
    className="rounded-full bg-slate-900 px-4 py-2 text-xs font-medium text-white shadow-lg shadow-slate-900/30"
  >
    Sign in / Register
  </button>
</nav>
    </header>

     {/* <div
      className={`fixed top-0 right-0 h-full bg-gray-100 shadow-lg transform ${
        isSidebarOpen ? "translate-x-0" : "translate-x-full"
      } transition-transform duration-300 z-50 w-[250px]`}
    >
      <div className="p-4">
        <div className="flex justify-between">
          <h2 className="text-lg font-bold mb-4">Menu</h2>
          <p onClick={toggleSidebar}>
            <i className="fa-solid fa-circle-chevron-right text-xl"></i>
          </p>
        </div>
        <ul className="space-y-4">
          <li><Link to="/" className="text-blue-500 block" onClick={toggleSidebar}>Home</Link></li>
          <li><Link to="/ship-for-sale" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Ship Sale/Purchase</Link></li>
          <li><Link to="/map/ship-chartering" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Open ships</Link></li>
          <li><Link to="/map/open-cargo" className="text-gray-800 hover:text-blue-300 block" onClick={toggleSidebar}>Open Cargo</Link></li>
          <li><Link to="/supplyEq" className="text-gray-800 hover:text-blue-300 block" onClick={toggleSidebar}>Supply Equipments</Link></li>
          <li><Link to="/contact" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Contact Us</Link></li>
          <li><Link to="/login" className="bg-blue-600 text-white  rounded py-2 px-2 block text-center" onClick={toggleSidebar}>Login</Link></li>
          <li><Link onClick={() => setIsLoginOpen(true)} className="bg-[#d1a460] text-black hover:bg-[#af9164] rounded py-2 px-2 block text-center" >+ Register your Ship</Link></li>
        </ul>
      </div>
    </div> */}

    {/* RADIAL HUB: Mariniz in center + 4 cards around */}
    <div className="mt-8 w-full max-w-6xl md:mt-0 xm:mt-14   md:w-[100%] mx-auto flex items-center justify-center">
      <div
        className="
          relative w-full aspect-[16/9]
          rounded-[36px] overflow-visible
        "
      >
        {/* 'water' reflection band at bottom (optional) */}
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 opacity-90" />

     <div
  className="
    relative z-10
      h-full w-full
    grid
    grid-cols-2
    gap-5
    md:grid-cols-1
    px-4 py-4
  "
>
  {/* ==== CARD 1 – TOP LEFT – Ships for Sale ==== */}
  <div
    onClick={() => navigate('/ship-for-sale')}
    className="
      absolute cursor-pointer transition hover:scale-105 duration-300
      top-[8%] -left-[9%]
      mid-1600-1800:-left-[18%]
      mid-1600-1800:top-[28%]
      3xl:static 3xl:top-auto 3xl:left-auto 3xl:right-auto 3xl:bottom-auto
      3xl:mx-auto
      md:w-[100%] 
      xm:blur-3
    "
  >
    <div
      className="
        relative w-[350px] h-[250px]  md:w-[100%]  md:h-auto rounded-[28px] overflow-hidden
        flex flex-col items-center pt-6
        bg-white/20
        border border-blue-800
        md:grid md:grid-cols-2
        md:px-3
      "
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.75),transparent_60%)]" />
      <div className="pointer-events-none absolute left-4 top-4 h-7 w-7 rounded-full border border-white/70 bg-white/20 shadow-[0_0_14px_rgba(255,255,255,0.9)]" />
      <div className="relative z-10 h-24 w-24 rounded-full overflow-hidden bg-white shadow-[0_10px_25px_rgba(15,23,42,0.25)] flex items-center justify-center mb-4 border border-white/70">
        <img
          src={browseship}
          alt="Browse Ships"
          className="h-full w-full object-cover"
        />
      </div>
      <p className="relative  z-10 text-[#123557] text-xl font-semibold md:px-8 xm:px-0 md:text-right xm:text-left px-6 text-left flex flex-col">
        <span>Ships for Sale</span>
        <span className=" md:text-right gap-2 mt-1 xm:text-left text-xs tracking-wide text-[#345f85]">
          Find the right vessel
          <span className="inline-block text-2xl xm:text-left md:text-right font-bold text-[#f5d48a] animate-poke-right">
            →
          </span>
        </span>
      </p>
    </div>
  </div>

  {/* ==== CARD 3 – Open Cargo ==== */}
  <div
    onClick={() => navigate('/map/open-cargo')}
    className="
      absolute cursor-pointer transition hover:scale-105 duration-300
      bottom-0 -left-[9%]
      mid-1600-1800:-left-[18%] mid-1600-1800:-bottom-[28%]
      3xl:static 3xl:top-auto 3xl:left-auto 3xl:right-auto 3xl:bottom-auto
      3xl:mx-auto
      md:w-[100%]
      
    "
  >
    <div
      className="
        relative w-[350px] h-[250px] md:w-[100%] md:h-auto rounded-[28px] overflow-hidden
        flex flex-col items-center pt-6
        bg-white/20
        border border-blue-800
        md:grid md:grid-cols-2
        md:px-3
      "
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.75),transparent_60%)]" />
      <div
        className="pointer-events-none absolute left-4 top-4 h-7 w-7 rounded-full
        border border-white/70 bg-white/20
        shadow-[0_0_14px_rgba(255,255,255,0.9)] "
        
      />
      <div className="relative z-10 h-24 w-24 rounded-full overflow-hidden bg-white shadow-[0_10px_25px_rgba(15,23,42,0.25)] flex items-center justify-center mb-4 border border-white/70">
        <img
          src={opencargoimage}
          alt="Open cargo"
          className="h-full w-full object-cover"
        />
      </div>
      <p className="relative  z-10 text-[#123557] text-xl font-semibold md:px-8 xm:px-0 md:text-right xm:text-left px-6 text-left flex flex-col">
        <span>Open Cargo</span>
        <span className=" md:text-right gap-2 mt-1 xm:text-left text-xs tracking-wide text-[#345f85]">
          Available Cargo Looking For Ships
          <span className="inline-block text-2xl xm:text-left md:text-right font-bold text-[#f5d48a] animate-poke-right">
            →
          </span>
        </span>
      </p>
    </div>
  </div>

  {/* ==== CARD 2 – Open Ships ==== */}
  <div
    onClick={() => navigate('/map/ship-chartering')}
    className="
      absolute cursor-pointer transition hover:scale-105 duration-300
      top-[8%] -right-[8%]
      mid-1600-1800:top-[29%] mid-1600-1800:-right-[12%]
      3xl:static 3xl:top-auto 3xl:left-auto 3xl:right-auto 3xl:bottom-auto
      3xl:mx-auto md:w-[100%]
    "
  >
    <div
      className="
        relative w-[350px] h-[250px]  md:w-[100%] md:h-auto rounded-[28px] overflow-hidden
        flex flex-col items-center pt-6
        bg-white/20
        border border-blue-800
        md:grid md:grid-cols-2
        md:px-3
      "
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.75),transparent_60%)]" />
      <div className="pointer-events-none absolute left-4 top-4 h-7 w-7 rounded-full border border-white/70 bg-white/20 shadow-[0_0_14px_rgba(255,255,255,0.9)]" />
      <div className="relative z-10 h-24 w-24 rounded-full overflow-hidden bg-white shadow-[0_10px_25px_rgba(15,23,42,0.25)] flex items-center justify-center mb-4 border border-white/70">
        <img
          src={openshipimage}
          alt="Open ship"
          className="h-full w-full object-cover"
        />
      </div>
      <p className="relative  z-10 text-[#123557] text-xl font-semibold md:px-8 xm:px-0 md:text-right xm:text-left px-6 text-left flex flex-col">
        <span>Open Ships</span>
        <span className=" md:text-right gap-2 mt-1 xm:text-left text-xs tracking-wide text-[#345f85]">
          Available Ships for Charter
          <span className="inline-block text-2xl xm:text-left md:text-right font-bold text-[#f5d48a] animate-poke-right">
            →
          </span>
        </span>
      </p>
    </div>
  </div>

  {/* ==== CARD 4 – Register Your Cargo / Ships ==== */}
  <div
    onClick={() => navigate('/regShip')}
    className="
      absolute cursor-pointer transition hover:scale-105 duration-300
      -bottom-[0%] -right-[8%]
      mid-1600-1800:-bottom-[28%] mid-1600-1800:-right-[18%]
      3xl:static 3xl:top-auto 3xl:left-auto 3xl:right-auto 3xl:bottom-auto
      3xl:mx-auto md:w-[100%]
    "
  >
    <div
      className="
        relative w-[350px] h-[250px] md:w-[100%] md:h-auto rounded-[28px] overflow-hidden
        flex flex-col items-center pt-6
        bg-white/20
        border border-blue-800
        md:grid md:grid-cols-2
        md:px-3
      "
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.75),transparent_60%)]" />
      <div className="pointer-events-none absolute left-4 top-4 h-7 w-7 rounded-full border border-white/70 bg-white/20 shadow-[0_0_14px_rgba(255,255,255,0.9)]" />
      <div className="relative z-10 h-24 w-24 rounded-full overflow-hidden bg-white shadow-[0_10px_25px_rgba(15,23,42,0.25)] flex items-center justify-center mb-4 border border-white/70">
        <img
          src={Newbg}
          alt="Browse Ships"
          className="h-full w-full object-cover"
        />
      </div>
      <p className="relative  z-10 text-[#123557] text-xl font-semibold md:px-8 xm:px-0 md:text-right xm:text-left px-6 text-left flex flex-col">
        <span>Register Your Cargo / Ships</span>
        <span className=" md:text-right gap-2 mt-1 xm:text-left text-xs tracking-wide text-[#345f85]">
          Post your vessel
          <span className="inline-block text-2xl xm:text-left md:text-right font-bold text-[#f5d48a] animate-poke-right">
            →
          </span>
        </span>
      </p>
    </div>
  </div>
</div>



      </div>
    </div>
  </div>
</motion.section>





      {/* MAIN CONTENT */}
      <main className="m-auto px-[50px]  overflow-x-hidden  lg:px-0">
        {/* Futuristic Marine marketplace – ALWAYS visible, with parallax zoom */}
        


 {/* FEATURE STRIP */}
        

        {/* Ships For Sale  */}
   <section className="mb-16 py-8 m-auto sm:px-6 lg:px-8">
  <h1 className="text-balance text-center text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl lg:text-[3.25rem]">
    Ships for Sale
  </h1>

  {/* Full-width slider wrapper */}
  <div className="mt-10 w-full max-w-8xl mx-auto relative ships-slider">
    <Slider c ref={ShipsliderRef} {...ship}>
      {sortedData.slice(0, 4).map((card, index) => {
        let imageUrl = null;
        const images = card.isFromReg
          ? allImagesReg.filter((img) => img.ships === card.id)
          : allImages.filter((img) => img.ship === card.id);

        imageUrl = images[0]?.image;
        const route = card.isFromReg
          ? `/singleShipReg/${card.id}`
          : `/singleShiphome/${card.id}`;

        return (
          // wrapper keeps each card centered; px-2 = small horizontal spacing
          <div key={card.id ?? index} className="flex justify-center px-2">
            <article
              className="
              m-auto
                relative flex flex-col overflow-hidden
                rounded-[26px] border-2 border-[#d1a460]
                bg-[#123d5f] text-slate-100
                h-[360px] w-[280px]
              "
            >
              {card.is_status === true && (
                <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/60">
                  <span className="rotate-[-20deg] text-2xl font-bold text-red-500">
                    Out of Stock
                  </span>
                </div>
              )}

              {imageUrl && (
                <div
                  className="relative h-[200px] w-full cursor-pointer overflow-hidden"
                  onClick={() => navigate(route)}
                >
                  <img
                    src={imageUrl}
                    alt={card.title || "Ship"}
                    className="h-full w-full"
                  />
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

                  {card.ship_type && (
                    <div className="absolute left-4 top-3 rounded-full bg-black/60 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-white">
                      {card.ship_type}
                    </div>
                  )}

                  <div className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-full bg-black/50 text-[11px] text-white">
                    •
                  </div>
                </div>
              )}

              <div className="flex flex-1 flex-col justify-between px-5 pb-5 pt-4">
                <div className="space-y-1">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">
                    {card.vessel_type || "Vessel Type"}
                  </p>
                  <h3 className="text-lg font-semibold tracking-tight line-clamp-1">
                    {card.short_description || "Ship Listing"}
                  </h3>

                  <p className="mt-1 text-[11px] uppercase tracking-[0.18em] text-slate-400">
                    {card.DWT && <span>DWT: {card.DWT}</span>}
                  </p>

                  <p className="text-[11px] leading-relaxed text-slate-400">
                    {card.dwt && <span>DWT: {card.dwt} &nbsp;·&nbsp;</span>}
                    {card.year_built && <span>Built year: {card.year_built}</span>}
                  </p>
                </div>

                <div className="mt-3 flex items-center justify-between gap-2">
                  <button
                    onClick={() => navigate(route)}
                    className="rounded-full bg-[#d1a460] px-4 py-1.5 text-[11px] font-semibold text-slate-900"
                  >
                    View Details
                  </button>

                  
                </div>
              </div>
            </article>
          </div>
        );
      })}
    </Slider>
  </div>
</section>

{/* Open Ships */}


<section className="mb-16sm:px-6 lg:px-8">
  <h1 className="text-balance text-center text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl lg:text-[3.25rem]">
    Open Ships
  </h1>

  {/* Full-width slider wrapper */}
  <div className="mt-10 w-full max-w-8xl mx-auto relative ships-slider">
    <Slider ref={ShipsliderRef} {...ship}>
      {openShip.slice(0, 4).map((card, index) => {
      
      

        return (
          // wrapper keeps each card centered; px-2 = small horizontal spacing
          <div key={card.id ?? index} className="flex justify-center ">
            <article
              className="
                relative flex flex-col overflow-hidden
                rounded-[26px] border-2 border-[#2e5775]
                bg-white/80 text-[#2e5775]
                h-[360px] w-[280px] m-auto
              "
            >
             

              <p className="text-[15px] p-5 bg-[#2e5775] text-white font-semibold uppercase tracking-[0.18em] ">
                    {card.vessel_type || "Vessel Type"}
                  </p>

              <div className="flex flex-1 flex-col justify-between text-[#d1a460] px-5  pb-5 pt-4">
               
                <div className="space-y-1">
                  
                  <h3 className="text-lg  ">
                   <span className="font-semibold">Open Area :</span> {card.open_area || "Open Area"}
                  </h3>

                  <h3 className="text-lg  ">
                   <span className="font-semibold">Capacity :</span> {card.DWT || "DWT "}
                  </h3>

                  <h3 className="text-lg  ">
                   <span className="font-semibold">Built Year :</span> {card.year_built || "Built Year"}
                  </h3>

                  
                  <h3 className="text-lg  ">
                   <span className="font-semibold">Lychan :</span> {card.lychan || "Lychan"}
                  </h3>


                 

                
                </div>

                <div className="mt-3 flex items-center justify-between gap-2">
                  <button
                   onClick={() => setIsLoginOpen(true)}
                    className="rounded-full bg-[#2e5775] px-4 py-1.5 text-[11px] font-semibold text-white"
                  >
                    Contact Owner
                  </button>
                 <button
                   onClick={() => navigate('/map/ship-chartering')}
                    className="rounded-full bg-gray-50 border border-gray-300 px-4 py-1.5 text-[11px] font-semibold text-slate-900"
                  >
                    View in Map 
                  </button>

                  
                </div>
              </div>
            </article>
          </div>
        );
      })}
    </Slider>
  </div>

  

</section>

{/* open cargo */}
<section className="mb-16 mt-10 sm:px-6 lg:px-8">
  <h1 className="text-balance text-center text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl lg:text-[3.25rem]">
    Open cargo
  </h1>

  {/* Full-width slider wrapper */}
  <div className="mt-10 w-full max-w-8xl mx-auto relative ships-slider">
    <Slider ref={ShipsliderRef} {...ship}>
      {cargos.slice(0, 4).map((card, index) => {
        let imageUrl = null;
        const images = card.isFromReg
          ? allImagesReg.filter((img) => img.ships === card.id)
          : allImages.filter((img) => img.ship === card.id);

        imageUrl = images[0]?.image;
      

        return (
          // wrapper keeps each card centered; px-2 = small horizontal spacing
          <div key={card.id ?? index} className="flex justify-center ">
            <article
              className="
                relative flex flex-col overflow-hidden
                rounded-[26px] border-2 border-[#d1a460]
                bg-white/80 text-[#2e5775]
                h-[360px] w-[280px] m-auto
              "
            >
             

              <p className="text-[15px] p-5 bg-[#d1a460] text-white font-semibold uppercase tracking-[0.18em] ">
                    {card.type_of_cargo || "Cargo Type"}
                  </p>

              <div className="flex flex-1 flex-col justify-between px-5  pb-5 pt-4">
               
                <div className="space-y-1">
                  
                  <h3 className="text-lg  ">
                   <span className="font-semibold">Loading Port :</span> {card.loading_port || "Loading Port"}
                  </h3>

                  <h3 className="text-lg  ">
                   <span className="font-semibold">Discharge Port :</span> {card.discharge_port || "Discharge Port"}
                  </h3>

                  <h3 className="text-lg  ">
                   <span className="font-semibold">Tonnage :</span> {card.tonnage || "Tonnage"}
                  </h3>


                 

                  <p className="text-[11px] leading-relaxed text-slate-400">
                   
                    {card.year_built && <span>Built year: {card.year_built}</span>}
                  </p>
                </div>

                <div className="mt-3 flex items-center justify-between gap-2">
                  <button
                   onClick={() => setIsLoginOpen(true)}
                    className="rounded-full bg-[#d1a460] px-4 py-1.5 text-[11px] font-semibold text-slate-900"
                  >
                    Contact Owner
                  </button>
                 <button
                   onClick={() => navigate('/map/open-cargo')}
                    className="rounded-full bg-gray-50 border border-gray-300 px-4 py-1.5 text-[11px] font-semibold text-slate-900"
                  >
                    View in Map 
                  </button>

                  
                </div>
              </div>
            </article>
          </div>
        );
      })}
    </Slider>
  </div>

  
{isLoginOpen && (
<div className="fixed inset-0  bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-gray-50 p-5  rounded-lg w-[40%] xm:w-[95%] relative">
        {/* Close button */}
        <button
          className="absolute right-3 top-3 text-gray-500 hover:text-red-500"
           onClick={() => setIsLoginOpen(false)}
        >
          ✕
        </button>

        {Signin === "Signin" && (
          <>
             <div>
              <img src={Logo} className="w-[276px]  m-auto -mt-4 " alt="" />
              <h1 className="text-center text-[24px] ">Login</h1>
              </div>
            <form
              className="flex flex-col mt-3 gap-7"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSubmit();
                }
              }}
            >
              {/* Username Field */}
              <input
                type="text"
                placeholder="Email or Username"
                value={username}
                onChange={(e) => {
                  setusername(e.target.value);
                  validateUsername(e.target.value);
                }}
                onBlur={() => validateUsername(username)}
                className={`w-full px-3 py-2 border ${
                  usernameError ? "border-red-500" : "border-gray-300"
                } rounded-lg`}
              />

              {/* Password Field */}
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    validatePassword(e.target.value);
                  }}
                  onBlur={() => validatePassword(password)}
                  className={`w-full px-3 py-2 border ${
                    passwordError ? "border-red-500" : "border-gray-300"
                  } rounded-lg`}
                />
                <div
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="fa-solid fa-eye-slash"></i>
                  ) : (
                    <i className="fa-solid fa-eye"></i>
                  )}
                </div>
              </div>

              {/* Remember Me & Forgot Password */}
              <div className="flex justify-between items-center text-sm">
                <p>
                  Not a Member?{" "}
                  <Link
                    onClick={() => setSignin("Signup")}
                    className="text-[#d1a460] font-semibold"
                  >
                    Signup
                  </Link>
                </p>
                <button
                  type="button"
                  onClick={() => setSignin("resetpswd")}
                  className="text-blue-500 hover:underline"
                >
                  Forgot Password?
                </button>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
                className="w-full bg-[#253356] text-white py-2 rounded-lg hover:bg-[#1b2a4f] disabled:cursor-not-allowed"
                disabled={
                  usernameError || passwordError || !username || !password
                }
              >
                {loading ? (
                  <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white rounded-full m-auto animate-spin"></span>
                ) : (
                  "Login"
                )}
              </button>
            </form>
          </>
        )}

        {/* Reset Password View */}
        {Signin === "resetpswd" && (
          <>
            <div className="flex justify-between items-center">
              <h1 className="text-xl">Recover Password</h1>
              <button onClick={() => setSignin("Signin")}>
                <i className="bx bx-arrow-back text-3xl text-blue-500"></i>
              </button>
            </div>
            <p className="mt-2 text-gray-500 text-sm">
              Enter your Email and instructions will be sent to you!
            </p>
            <form className="mt-4" onSubmit={(e) => { e.preventDefault(); handleForgotPassword(); }}>
  <input
    type="email"
    placeholder="Enter your Email"
    value={resetEmail}
    onChange={(e) => setResetEmail(e.target.value)}
    className="w-full rounded-lg border py-3 p-2"
  />
  <button
    type="submit"
    disabled={resetLoading}
    className="mt-4 bg-[#FB9678] w-full p-3 rounded-lg text-white font-semibold hover:bg-[#e97a58]"
  >
    {resetLoading ? "Sending..." : "RESET"}
  </button>
</form>
          </>
        )}

        {/* Signup */}
          {Signin === "Signup" && (
            <>
              <div>
               <img src={Logo} className="w-[276px]  m-auto -mt-4 " alt="" />
                <h1 className="text-center text-[24px] ">Signup</h1>
              </div>

             <form
  className="flex flex-col gap-7 mx-auto mt-5"
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmitSignup();
    }
  }}
>
  {/* First Name */}
  <div className="relative flex gap-10 w-full group">
    <input
      type="text"
      placeholder="First Name"
      value={firstName}
      onChange={(e) => setFirstName(e.target.value)}
      className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
    />

    <input
      type="text"
      placeholder="Last Name"
      value={lastName}
      onChange={(e) => setLastName(e.target.value)}
      className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
    />
  </div>

  {/* Username */}
  <div className="relative flex gap-10 w-full group">
    <input
      type="text"
      placeholder="Username"
      value={username}
      onChange={(e) => {
        setusername(e.target.value);
        validateUsername(e.target.value);
      }}
      onBlur={() => validateUsername(username)}
      className={`w-[50%] px-1 py-1 border-b ${
        usernameError ? "border-red-500" : "border-gray-400"
      } focus:outline-none focus:ring-0 bg-transparent`}
    />

     <input
      type="email"
      placeholder="Email"
      value={email}
      onChange={(e) => {
        setEmail(e.target.value);
        validateEmail(e.target.value);
      }}
      onBlur={() => validateEmail(email)}
      className={`w-[50%] px-1 py-1 border-b ${
        emailError ? "border-red-500" : "border-gray-400"
      } focus:outline-none focus:ring-0 bg-transparent`}
    />
  </div>

  {/* Company Name */}
  <div className="relative flex gap-10 w-full group">
    <input
      type="text"
      placeholder="Company Name"
      value={companyName}
      onChange={(e) => setCompanyName(e.target.value)}
      className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
    />
 <div className="w-[50%]">
    <input
      type="text"
      placeholder="Mobile Number"
      value={mobile}
      onChange={(e) => {
        setMobile(e.target.value);
        validateMobile(e.target.value);
      }}
      onBlur={() => validateMobile(mobile)}
      className={`w-full px-1 py-1 border-b ${
        mobileError ? "border-red-500" : "border-gray-400"
      } focus:outline-none focus:ring-0 bg-transparent`}
    />

    {/* ✅ Show error message */}
    {mobileError && (
      <p className="text-red-500 italic text-sm mt-1">
        *Please enter a valid mobile number (e.g., +971501234567).
      </p>
    )}
  </div>
  </div>

  {/* Address */}
  <div className="relative w-full group">
    <input
      type="text"
      placeholder="Address"
      value={address}
      onChange={(e) => setAddress(e.target.value)}
      className="w-full px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
    />
  </div>

 

 

  {/* Password */}
  <div className="relative w-full group">
  <input
    type={showPassword ? "text" : "password"}
    placeholder="Password"
    value={password}
    onChange={(e) => {
      setPassword(e.target.value);
      validatePassword(e.target.value);
    }}
    onBlur={() => validatePassword(password)}
    className={`w-full px-1 py-1 border-b ${
      passwordError ? "border-red-500" : "border-gray-400"
    } focus:outline-none focus:ring-0 bg-transparent pr-8`}  // Add pr-8 for icon space
  />

  {/* Eye icon */}
  <div
    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
    onClick={() => setShowPassword(!showPassword)}
  >
    {showPassword ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
  </div>

  {passwordError && (
    <p className="text-red-500 italic text-sm mt-1">
      *Password must be at least 6 characters and contain at least 1 letter and 1 number.
    </p>
  )}
</div>



  {/* Confirm Password */}
  <div className="relative w-full group">
  <input
    type={showConfirmPassword ? "text" : "password"}
    placeholder="Confirm Password"
    value={confirmPassword}
    onChange={(e) => {
      setConfirmPassword(e.target.value);
      validateConfirmPassword(e.target.value);
    }}
    onBlur={() => validateConfirmPassword(confirmPassword)}
    className={`w-full px-1 py-1 border-b ${
      confirmPasswordError ? "border-red-500" : "border-gray-400"
    } focus:outline-none focus:ring-0 bg-transparent pr-8`}
  />

  {/* Eye icon */}
  <div
    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
  >
    {showConfirmPassword ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
  </div>

  {confirmPasswordError && (
    <p className="text-red-500 italic text-sm mt-1">
      *Passwords do not match.
    </p>
  )}
</div>



   <div className='flex items-center gap-4'>
                <label className='text-gray-400 ' htmlFor="image">Image:</label>
                <input
                  className='px-2  rounded-xl'
                  type="file"
                  onChange={(e) => setImage(e.target.files[0])}
                  id='image'
                />
              </div>

  {/* Signup Button */}
  <button
    type="submit"
    onClick={(e) => {
      e.preventDefault();
      handleSubmitSignup();
    }}
    className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 disabled:cursor-not-allowed transition duration-200 disabled:bg-gray-300"
    disabled={
      usernameError ||
      emailError ||
      mobileError ||
      passwordError ||
      confirmPasswordError ||
      !username ||
      !email ||
      !mobile ||
      !password ||
      !confirmPassword
    }
  >
    {loading ? (
      <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white mt-[4px] mb-[4px] rounded-full m-auto animate-spin"></span>
    ) : (
      "Signup"
    )}
  </button>

  {/* Already have account? */}
  <div className="text-sm text-center">
    Already have an account?{" "}
    <Link onClick={() => setSignin("Signin")} className="text-[#d1a460] font-semibold">
      Login
    </Link>
  </div>
</form>

            </>
          )}
         
      </div>
    </div>
)}
</section>




          {/* Newsletter Section */}
<div className=" py-10 mb-16 px-5 mt-10">
  <div className="w-[90%] xm:w-[100%] flex-wrap mx-auto flex justify-between bg-gray-50 shadow-xl rounded-xl p-8 ">
   <div className="w-[50%] xm:w-[100%]">
      <h2 className="text-3xl drop-shadow-md font-bold text-[#123d5f] mb-4">
        Subscribe to Our Newsletter & weekly Free E book
      </h2>
      <p className="text-gray-600 drop-shadow-md  w-[70%] xm:w-[100%] mb-4">
        Stay updated with the latest ships available for sale and charter.  
        Select your preferences below and never miss an update!
      </p>
   </div>

    <div className="w-[40%] xm:w-[100%]">
      {/* Form */}
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
          placeholder="Enter your email"
          className="w-[60%] xm:w-[100%] px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#123d5f]"
          required
        />
  
        {/* Checkboxes */}
        <div className="flex flex-col xm:flex-col sm:flex-row gap-4 justify-center">
          <label className="flex items-center gap-2 text-gray-700">
            <input 
            checked={shipForSale}
            onChange={(e) => setShipForSale(e.target.checked)} 
            type="checkbox" className="w-4 h-4" />  
            Newsletter for Ship for Sale
          </label>
          <label className="flex items-center gap-2 text-gray-700">
            <input 
            type="checkbox"
            checked={shipForCharter}
            onChange={(e) => setShipForCharter(e.target.checked)} className="w-4 h-4" />  
            Newsletter for Ship for Charter
          </label>
        </div>
  
        {/* Subscribe Button */}
        <button
          type="submit"
          className="bg-[#d1a460] w-[60%] xm:w-[100%] hover:bg-[#d1a46088] text-white px-6 py-3 rounded-lg shadow-lg transition duration-300"
        >
          Subscribe
        </button>
      </form>
    </div>
  </div>
</div>

       

        

        
      </main>
      <NewFooter/>
    </div>
  );
};

export default NewHome;
